<template>
  <div class="relative-position">
    <div class="fixed-top">
      <div class="d-flex justify-content-end start-50 translate-middle-x" style="z-index: 1050">
        <h3></h3>
        <!-- <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged" style="width: 25%; margin-top: 5%">
          Success <br />
          Daily Results has been Updated
          <b-progress variant="success" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress>
        </b-alert> -->
      </div>
    </div>
    <section class="practice">
      <b-modal id="my-modal" class="daily-results" ref="result_model" @ok="addEditEvent">
        <template #modal-title>
          <div style="display: flex; justify-content: space-between">
            <div>Input Daily Results</div>
            <div style="margin-left: 150px">
              {{ formatDate(modelVal.start) }}
            </div>
          </div>
        </template>
        <form class="form-horizontal calender-popup label-width" data-parsley-validate="true" name="demo-form"
          novalidate="" id="inputresults">
          <div class="panel panel-default Focuses" id="NP" v-if="modelVal.showNP">
            <div class="panel-body">
              <div class="row control-pform">
                <div class="col-md-12">
                  <h4>New Patients:</h4>
                  <div class="row">
                    <div class="col-md-3">
                      <label class="control-label btm color-redish">Goal:
                      </label>
                      <input class="form-control" id="NPGoal" name="NPGoal" type="text" :readonly="isDisabled"
                        :disabled="this.loginUser.Status !== 'PDC'" v-model="modelVal.NPGoal" @click="showConfirmModal"
                        style="
                          width: 60px;
                          background-color: rgb(255, 255, 255);
                        " />

                      <b-modal ref="confirm_modal" hide-footer title="Confirmation">
                        <p>
                          This will change the goal for this date. To change
                          goals for this quarter, use Input Goals by Quarter.
                        </p>
                        <b-button variant="primary" @click="confirmDisableAndFocus">Yes</b-button>
                        <b-button variant="secondary" @click="hideConfirmModalAndDisable">No</b-button>
                      </b-modal>
                    </div>
                    <div class="col-md-3">
                      <label class="control-label btm color-blue">Actual:
                      </label>
                      <input style="width: 60px" class="form-control isNumber" id="NPActual" name="NPActual"
                        v-model="modelVal.NPActual" type="text" tabindex="1" :disabled="isNPInputDisabled()" />
                    </div>

                    <div id="new_patient" class="col-md-3" v-html="modelHTML.new_patient"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel panel-default Focuses" id="ROF" v-if="modelVal.showROF">
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <h4>Report of Findings:</h4>
                  <div class="row control-pform">
                    <div class="col-md-3">
                      <label class="control-label btm color-redish">Arrived:
                      </label>
                      <input style="width: 60px" class="form-control isNumber" id="ROFArrived" name="ROFArrived"
                        v-model="modelVal.ROFArrived" type="text" tabindex="2" :disabled="isROFInputDisabled()" />
                    </div>
                    <div class="col-md-3">
                      <label class="control-label btm color-blue">Started:
                      </label>
                      <input style="width: 60px" class="form-control isNumber" id="ROFStarted" name="ROFStarted"
                        v-model="modelVal.ROFStarted" type="text" tabindex="3" :disabled="isROFInputDisabled()" />
                    </div>
                    <div id="report_of_findings_arrived" class="col-md-3" v-html="modelHTML.report_of_findings_arrived">
                    </div>
                    <div id="report_of_findings_started" class="col-md-3 width_auto"
                      v-html="modelHTML.report_of_findings_started"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel panel-default Focuses" id="PV" v-if="modelVal.showPV">
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <h4>Patient Visits:</h4>
                  <div class="row control-pform">
                    <div class="col-md-3">
                      <label class="control-label btm color-redish">Goal:
                      </label>
                      <input style="
                          width: 60px;
                          background-color: rgb(255, 255, 255);
                        " class="form-control" id="PVGoal" v-model="modelVal.PVGoal" name="PVGoal" type="text"
                        :readonly="isPVDisabled" @click="showConfirmModalPV" ref="PVGoal"
                        :disabled="this.loginUser.Status !== 'PDC'" />

                      <b-modal ref="confirm_modal_pv" hide-footer title="Confirmation">
                        <p>
                          This will change the goal for this date. To change
                          goals for this quarter, use Input Goals by Quarter.
                        </p>
                        <b-button variant="primary" @click="confirmDisablePVAndFocus">Yes</b-button>
                        <b-button variant="secondary" @click="hideConfirmModalPVAndDisable">No</b-button>
                      </b-modal>
                    </div>
                    <div class="col-md-3">
                      <label class="control-label btm color-blue">Actual:
                      </label>
                      <input style="width: 60px" class="form-control isNumber" id="PVActual" name="PVActual"
                        v-model="modelVal.PVActual" type="text" tabindex="4" :disabled="isPVInputDisabled()" />
                    </div>
                    <div id="patient_visits" class="col-md-3" v-html="modelHTML.patient_visits"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel panel-default Focuses" id="CPR" v-if="modelVal.showCPR">
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <h4>Care Plan Renewals:</h4>
                  <div class="row control-pform">
                    <div class="col-md-3">
                      <label class="control-label btm color-redish">Arrived:
                      </label>
                      <input style="width: 60px" class="form-control isNumber" id="CPRArrived" name="CPRArrived"
                        v-model="modelVal.CPRArrived" type="text" tabindex="5" :disabled="isRCPRInputDisabled()" />
                    </div>
                    <div class="col-md-3">
                      <label class="control-label btm color-blue">Started:
                      </label>
                      <input style="width: 60px" class="form-control isNumber" id="CPRStarted" name="CPRStarted"
                        v-model="modelVal.CPRStarted" type="text" tabindex="6" :disabled="isRCPRInputDisabled()" />
                    </div>
                    <div id="care_plan_arrived" class="col-md-3" v-html="modelHTML.care_plan_arrived"></div>
                    <div id="care_plan_started" class="col-md-3 width_auto">
                      <div style="display: block; overflow: hidden" v-html="modelHTML.care_plan_started"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel panel-default Focuses" id="REV" v-if="modelVal.showREV">
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12 control-pform">
                  <h4>Revenue:</h4>
                  <div class="row control-pform">
                    <div class="col-md-3">
                      <label class="control-label btm color-redish">Goal:
                      </label>
                      <input class="form-control" id="REVGoal" name="REVGoal" type="text" :readonly="isDisabledREV"
                        v-model="modelVal.REVGoal" @click="showREVConfirmModal" style="
                          width: 62px;
                          background-color: rgb(255, 255, 255);
                        " :disabled="this.loginUser.Status !== 'PDC'" />
                    </div>

                    <!-- The modal and the methods remain the same, just copy them from the NPGoal field -->
                    <b-modal ref="revconfirm_modal" hide-footer title="Confirmation">
                      <p>
                        This will change the goal for this date. To change goals
                        for this quarter, use Input Goals by Quarter.
                      </p>
                      <b-button variant="primary" @click="confirmREVDisableAndFocus">Yes</b-button>
                      <b-button variant="secondary" @click="hideREVConfirmModalAndDisable">No</b-button>
                    </b-modal>
                    <div class="col-md-3">
                      <label class="control-label btm color-blue">Actual:
                      </label>
                      <!-- <div>{{ showacrev }}</div> -->
                      <input style="width: 62px" class="form-control" id="
                      " name="REVActual" type="text" tabindex="7" v-model="inputValue" placeholder="0"
                        :disabled="isREVInputDisabled()" @input="updateModelValue($event.target.value)" />
                    </div>
                    <div id="rev_actual" class="col-md-3" v-if="this.modelVal.REVActual != 0"
                      v-html="modelHTML.rev_actual">
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-pbtns">
            <div class="col-md-8">
              <label class="control-label" for="fullname">Note:</label>
              <textarea class="form-control" name="NOTES" id="NOTES" v-model="modelVal.MyNotes"></textarea>
            </div>
            <div class="col-md-4">
              <b-button size="sm" variant="success" @click="addEditEvent">
                Save
              </b-button>
              <b-button size="sm" variant="danger" @click="cancel()">
                Close
              </b-button>
            </div>
          </div>
        </form>
      </b-modal>

      <div v-if="isLoading" class="custom-loader-overlay">
        <div class="custom-loader"></div>
      </div>
      <div class="row">
        <aside class="col-md-3 col-sm-12 cus-sidebar">
          <practiceSidebar />
        </aside>
        <div v-if="isLoading1" class="loader">
          <div class="wave-container">
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
          </div>
          <p>Loading...</p>
        </div>
        <div id="content" class="content successReport col-md-9 col-sm-12"
          :style="{ display: isLoading1 ? 'none' : '' }">
          <div class="material-box bg-white">
            <div class="row content-row">
              <div class="col-md-12">
                <h3>Input Daily Results</h3>
              </div>

              <div class="col-md-12">
                <form action="" method="post">
                  <input type="hidden" name="pageName" id="pageName" value="InputResult" />
                  <div class="header-tools">
                    <div class="row">
                      <input type="hidden" id="UserID" value="2" />
                      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12"></div>
                      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12"></div>
                    </div>
                  </div>
                </form>

                <div class="header-button">
                  <p>
                    For each category, your Goal is on the left and your Result
                    is on the right, e.g. NP: 5 - 4. The Goal = 5 and Result =
                    4. NP = New Patient ROF = Report of Findings PV = Patient
                    Visits CPR = Care Plan Renewals R = Revenue
                  </p>
                </div>
                <!-- <FullCalendar :key="calendarKey" :options="calendarOptions" class="res-calendar">
                  <template v-slot:eventContent="arg">
                    <i v-html="arg.event.extendedProps.description" @click="openModal(arg)">
                    </i>
                  </template>
                </FullCalendar> -->
                <template>
                  <div>
                    <div class="calendar-controls" style="position: relative;">
                      <div class="control-group">
                        <label for="month-select">Month</label>
                        <select id="month-select" v-model="selectedMonth"
                          @change="onYearChange(selectedYear, selectedMonth)">
                          <option v-for="month in months" :value="month.value" :key="month.value">
                            {{ month.text }}
                          </option>
                        </select>
                      </div>
                      <div class="control-group">
                        <label for="year-select">Year</label>
                        <select id="year-select" v-model="selectedYear"
                          @change="onYearChange(selectedYear, selectedMonth)">
                          <option v-for="year in years" :value="year" :key="year">
                            {{ year }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <FullCalendar :key="calendarKey" :options="calendarOptions" class="res-calendar">
                      <template v-slot:eventContent="arg">
                        <i v-html="arg.event.extendedProps.description" @click="openModal(arg)">
                        </i>
                      </template>
                    </FullCalendar>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import practiceSidebar from "./components/Sidebar.vue";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import userAPI from "../userApi";
import moment from "moment";

export default {
  name: "ResultCalendar",

  components: {
    practiceSidebar,
    FullCalendar,
  },

  data() {
    return {
      selectedMonth: moment().format('M'),
      selectedYear: moment().format('YYYY'),
      months: [
        { value: '1', text: 'January' },
        { value: '2', text: 'February' },
        { value: '3', text: 'March' },
        { value: '4', text: 'April' },
        { value: '5', text: 'May' },
        { value: '6', text: 'June' },
        { value: '7', text: 'July' },
        { value: '8', text: 'August' },
        { value: '9', text: 'September' },
        { value: '10', text: 'October' },
        { value: '11', text: 'November' },
        { value: '12', text: 'December' },
      ],
      years: Array.from({ length: 20 }, (v, i) => moment().year() - 10 + i),

      inputValue: "",
      showacrev: 0,
      isDisabled: false,
      isPVDisabled: false,
      isDisabledREV: false,
      showDialog: false,
      calendarKey: 1,
      loginUser: {},
      isLoading: false,
      isLoading1: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      modelVal: {
        showNP: false,
        showROF: false,
        showREV: false,
        showCPR: false,
        showPV: false,
      },
      revenueVal: {},
      modelHTML: {
        new_patient: "",
        rev_actual: "",
        patient_visits: "",
        report_of_findings_started: "",
        report_of_findings_arrived: "",
        care_plan_arrived: "",
        care_plan_started: "",
      },
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        dateClick: this.selectDate,
        events: [],
        headerToolbar: {
          left: '',
          center: 'prev,title,next',
          right: ''
        },
        initialDate: moment().startOf("month").format("YYYY-MM-DD"),
        visibleRange: {
          start: moment().startOf("month").format("YYYY-MM-DD"),
          end: moment().endOf("month").format("YYYY-MM-DD"),
        },
      },
      formCalendar: {
        year: "",
        month: "",
        status: "",
        UserID: 0,
        PracticeID: "",
        day: "",
      },
    };
  },

  methods: {
    updateModelValue(value) {
      // Update modelVal.REVActual based on showacrev condition
      if (this.showacrev !== 0) {
        this.modelVal.REVActual = value;
      }
    },
    isNPInputDisabled() {
      if (
        !this.revenueVal ||
        !this.revenueVal.data ||
        !this.revenueVal.data.assignedFocuses
      ) {
        return false;
      } else if (
        !this.revenueVal.data.assignedFocuses.includes("New Patient") &&
        this.loginUser.Status != "PDC"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isROFInputDisabled() {
      if (
        !this.revenueVal ||
        !this.revenueVal.data ||
        !this.revenueVal.data.assignedFocuses
      ) {
        return false;
      } else if (
        !this.revenueVal.data.assignedFocuses.includes("Report of Findings") &&
        this.loginUser.Status != "PDC"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isPVInputDisabled() {
      if (
        !this.revenueVal ||
        !this.revenueVal.data ||
        !this.revenueVal.data.assignedFocuses
      ) {
        return false;
      } else if (
        !this.revenueVal.data.assignedFocuses.includes("Patient Visits") &&
        this.loginUser.Status != "PDC"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isRCPRInputDisabled() {
      if (
        !this.revenueVal ||
        !this.revenueVal.data ||
        !this.revenueVal.data.assignedFocuses
      ) {
        return false;
      } else if (
        !this.revenueVal.data.assignedFocuses.includes("Care Plan Renewals") &&
        this.loginUser.Status != "PDC"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isREVInputDisabled() {
      if (
        !this.revenueVal ||
        !this.revenueVal.data ||
        !this.revenueVal.data.assignedFocuses
      ) {
        return false;
      } else if (
        !this.revenueVal.data.assignedFocuses.includes("Revenue") &&
        this.loginUser.Status != "PDC"
      ) {
        return true;
      } else {
        return false;
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    showConfirmModal() {
      this.$refs["confirm_modal"].show();
    },
    hideConfirmModal() {
      this.$refs["confirm_modal"].hide();
    },
    confirmDisableAndFocus() {
      this.isDisabled = false;
      this.hideConfirmModal();
      this.$refs.NPGoal.focus();
    },
    showConfirmModalPV() {
      this.$refs["confirm_modal_pv"].show();
    },
    hideConfirmModalPV() {
      this.$refs["confirm_modal_pv"].hide();
    },
    confirmDisablePVAndFocus() {
      this.isPVDisabled = false;
      this.hideConfirmModalPV();
      this.$refs.PVGoal.focus();
    },
    hideConfirmModalPVAndDisable() {
      this.isPVDisabled = true;
      this.hideConfirmModalPV();
    },
    hideConfirmModalAndDisable() {
      this.isDisabled = true;
      this.hideConfirmModal();
    },
    showREVConfirmModal() {
      this.$refs["revconfirm_modal"].show();
    },
    hideREVConfirmModal() {
      this.$refs["revconfirm_modal"].hide();
    },
    confirmREVDisableAndFocus() {
      this.isDisabledREV = false;
      this.hideREVConfirmModal();
      this.$refs.REVGoal.focus();
    },
    hideREVConfirmModalAndDisable() {
      this.$refs["revconfirm_modal"].hide();
      this.isDisabledREV = true;
    },
    handleDateRangeChange(info) {
      const startDate = new Date(info.start);
      const dayOfMonth = startDate.getDate();
      let startMonth;

      if (dayOfMonth === 1) {
        startMonth = (startDate.getMonth() + 1) % 12;
      } else {
        startMonth = (startDate.getMonth() + 2) % 12;
      }
      if (startMonth === 0) {
        startMonth = 12;
      }
      let startYear = info.start.getFullYear();
      if (startMonth === 1 && startDate.getMonth() === 11) {
        startYear += 1;
      }
      this.selectedMonth = startMonth;
      this.getEvents1(startMonth, startYear);
    },
    addEditEvent() {
      this.isLoading = true;
      this.$refs.result_model.hide();
      this.modelVal.REVActual = this.inputValue;
      userAPI.addEditEvent(
        {
          ...this.modelVal,
          ...{
            PracticeID: this.loginUser.PracticeID,
            userID: this.loginUser.userID,
            Status: this.loginUser.Status,
          },
        },

        (res) => {
          this.calendarOptions.events = [];
          const specificParameter = this.modelVal.end;
          const dateObject = new Date(specificParameter);
          const month = dateObject.getMonth(); // Get the month (0-11)
          const year = dateObject.getFullYear();

          let startMonth;
          if (dateObject.getDate() === 1) {
            startMonth = (month + 1) % 12;
          } else {
            startMonth = (month + 1) % 12;
          }

          if (startMonth === 0) {
            startMonth = 12;
          }

          let startYear = year;
          if (startMonth === 1 && month === 11) {
            startYear += 1;
          }

          this.getEvents1(startMonth, startYear);
          this.showAlert();
        },
        (err) => {
          console.log(err);
        }
      );
    },
    cancel() {
      this.$refs.result_model.hide();
    },
    openModal(event) {
      // Set the description to some variable if needed
      // this.description = description; 
      this.selectDate2(event);
    },
    clearModelHTML() {
      this.modelHTML.new_patient = "";
      this.modelHTML.rev_actual = "";
      this.modelHTML.patient_visits = "";
      this.modelHTML.report_of_findings_arrived = "";
      this.modelHTML.report_of_findings_started = "";
      this.modelHTML.care_plan_arrived = "";
      this.modelHTML.care_plan_started = "";
      this.inputValue = "0";
    },
    selectDate2(eve) {
      this.isLoading = true;
      const formattedDate = moment(eve.event.start).format("Y-MM-DD");

      const eventStartDate = eve.event.start;

      // Extract year, month, and day using moment.js
      const year = moment(eventStartDate).format("YYYY");
      const month = moment(eventStartDate).format("M");
      const day = moment(eventStartDate).format("D");
      this.modelHTML = {
        new_patient: "",
        rev_actual: "",
        patient_visits: "",
        report_of_findings_started: "",
        report_of_findings_arrived: "",
        care_plan_arrived: "",
      };

      let mVal = this.calendarOptions.events.find((ele) => {
        return moment(ele.start).format("Y-MM-DD") == formattedDate;
      });
      if (mVal === undefined) {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: "No Event Found",
        });
        return false;
      } else {
        this.modelVal = mVal;
      }
      userAPI.getRevFocusDailyResult(
        {
          userID: this.loginUser.userID,
          year: moment(eve.date).format("Y"),
          month: moment(eve.date).format("M"),
          day: moment(eve.date).format("D"),
          PracticeID: this.loginUser.PracticeID,
        },
        (res) => {
          this.revenueVal = res.data;
        },
        (err) => {
          console.log(err);
        }
      );

      userAPI.getInputdailyResult(
        {
          year: year,
          month: month,
          day: day,
          PracticeID: this.loginUser.PracticeID,
        },

        (res) => {
          this.clearModelHTML(); 
          res = res.data.reverse();
          for (let i = 0; i < res.length; i++) {
            if (res[i].NPActual > 0) {
              this.modelHTML.new_patient +=
                '<label class="control-label btm color-blue">' +
                res[i].Name +
                ':</label><input style="width: 60px" class="form-control isNumber" disabled value="' +
                res[i].NPActual +
                '" id="np_actual_' +
                i +
                '" name="np_actual_' +
                i +
                '"   type="text" tabindex="1">';
            }
            if (res[i].REVActual > 0) {
              if (res[i].UserID == this.loginUser.userID) {
                this.showacrev = 1;
                this.inputValue = res[i].REVActual;
              }
              this.modelHTML.rev_actual +=
                '<label class="control-label btm color-blue">' +
                res[i].Name + 
                ':</label><input style="width: 60px; margin-left: 60%;" class="form-control isNumber" disabled value="' +
                res[i].REVActual +
                '" id="rev_actual_' +
                i +
                '" name="rev_actual_' +
                i +
                '"   type="text" tabindex="1">';
            }
            if (res[i].PVActual > 0) {
              this.modelHTML.patient_visits +=
                '<label class="control-label btm color-blue">' +
                res[i].Name +
                ':</label><input style="width: 60px" class="form-control isNumber" disabled value="' +
                res[i].PVActual +
                '" id="pv_actual_' +
                i +
                '" name="pv_actual_' +
                i +
                '"   type="text" tabindex="1">';
            }
            if (res[i].ROFArrived > 0) {
              this.modelHTML.report_of_findings_arrived +=
                '<label class="control-label btm color-blue">' +
                res[i].Name +
                ':</label><input style="width: 60px" class="form-control isNumber" disabled value="' +
                res[i].ROFArrived +
                '" id="rof_arrived_' +
                i +
                '" name="rof_arrived_' +
                i +
                '"   type="text" tabindex="1">';

              this.modelHTML.report_of_findings_started +=
                '<div style="display:block; overflow:hidden;"><input style="width: 60px" class="form-control isNumber" disabled value="' +
                res[i].ROFStarted +
                '" id="rof_started_' +
                i +
                '" name="rof_started_' +
                i +
                '"   type="text" tabindex="1"></div>';
            }
            if (res[i].CPRArrived > 0) {
              this.modelHTML.care_plan_arrived +=
                '<label class="control-label btm color-blue">' +
                res[i].Name +
                ':</label><input style="width: 60px" class="form-control isNumber" disabled value="' +
                res[i].CPRArrived +
                '" id="cpr_arrived_' +
                i +
                '" name="cpr_arrived_' +
                i +
                '"   type="text" tabindex="1">';

              this.modelHTML.care_plan_started +=
                '<div style="display:block; overflow:hidden;"><input style="width: 60px; " class="form-control isNumber" disabled value="' +
                res[i].CPRStarted +
                '" id="cpr_started_' +
                i +
                '" name="cpr_started_' +
                i +
                '"   type="text" tabindex="1"></div>';
            }
          }
          this.isLoading = false;
          this.$refs["result_model"].show();
        },
        (err) => {
          console.log(err);
        }
      );

    },
    selectDate(eve) {
      const formattedDate = moment(eve.date).format("Y-MM-DD");
      this.modelHTML = {
        new_patient: "",
        rev_actual: "",
        patient_visits: "",
        report_of_findings_started: "",
        report_of_findings_arrived: "",
        care_plan_arrived: "",
      };

      let mVal = this.calendarOptions.events.find((ele) => {
        return moment(ele.start).format("Y-MM-DD") == formattedDate;
      });
      console.log(formattedDate);

      if (mVal === undefined) {
        // this.$swal({
        //     type: 'error',
        //     title: 'Oops...',
        //     text: "No Event Found",
        // })
        // return false;
        let data = {
          start: formattedDate,
          end: formattedDate,
          showCPR: 1,
          showNP: 1,
          showPV: 1,
          showREV: 1,
        };
        this.modelVal = data;
      } else {
        this.modelVal = mVal;
      }
      userAPI.getRevFocusDailyResult(
        {
          year: moment(eve.date).format("Y"),
          month: moment(eve.date).format("M"),
          day: moment(eve.date).format("D"),
          PracticeID: this.loginUser.PracticeID,
        },
        (res) => {
          this.revenueVal = res.data;
        },
        (err) => {
          console.log(err);
        }
      );
      userAPI.getInputdailyResult(
        {
          year: moment(eve.date).format("Y"),
          month: moment(eve.date).format("M"),
          day: moment(eve.date).format("D"),
          PracticeID: this.loginUser.PracticeID,
        },
        (res) => {
          res = res.data;
          for (let i = 0; i < res.length; i++) {
            if (res[i].NPActual > 0) {
              this.modelHTML.new_patient +=
                '<label class="control-label btm color-blue">' +
                res[i].Name +
                ':</label><input style="width: 60px" class="form-control isNumber" disabled value="' +
                res[i].NPActual +
                '" id="np_actual_' +
                i +
                '" name="np_actual_' +
                i +
                '"   type="text" tabindex="1">';
            }
            if (res[i].REVActual > 0) {
              this.modelHTML.rev_actual +=
                '<label class="control-label btm color-blue">' +
                res[i].Name +
                ':</label><input style="width: 60px" class="form-control isNumber" disabled value="' +
                res[i].REVActual +
                '" id="rev_actual_' +
                i +
                '" name="rev_actual_' +
                i +
                '"   type="text" tabindex="1">';
            }
            if (res[i].PVActual > 0) {
              this.modelHTML.patient_visits +=
                '<label class="control-label btm color-blue">' +
                res[i].Name +
                ':</label><input style="width: 60px" class="form-control isNumber" disabled value="' +
                res[i].PVActual +
                '" id="pv_actual_' +
                i +
                '" name="pv_actual_' +
                i +
                '"   type="text" tabindex="1">';
            }
            if (res[i].ROFArrived > 0) {
              this.modelHTML.report_of_findings_arrived +=
                '<label class="control-label btm color-blue">' +
                res[i].Name +
                ':</label><input style="width: 60px" class="form-control isNumber" disabled value="' +
                res[i].ROFArrived +
                '" id="rof_arrived_' +
                i +
                '" name="rof_arrived_' +
                i +
                '"   type="text" tabindex="1">';

              this.modelHTML.report_of_findings_started +=
                '<div style="display:block; overflow:hidden;"><input style="width: 60px" class="form-control isNumber" disabled value="' +
                res[i].ROFStarted +
                '" id="rof_started_' +
                i +
                '" name="rof_started_' +
                i +
                '"   type="text" tabindex="1"></div>';
            }
            if (res[i].CPRArrived > 0) {
              this.modelHTML.care_plan_arrived +=
                '<label class="control-label btm color-blue">' +
                res[i].Name +
                ':</label><input style="width: 60px" class="form-control isNumber" disabled value="' +
                res[i].CPRArrived +
                '" id="cpr_arrived_' +
                i +
                '" name="cpr_arrived_' +
                i +
                '"   type="text" tabindex="1">';

              this.modelHTML.care_plan_started +=
                '<div style="display:block; overflow:hidden;"><input style="width: 60px; " class="form-control isNumber" disabled value="' +
                res[i].CPRStarted +
                '" id="cpr_started_' +
                i +
                '" name="cpr_started_' +
                i +
                '"   type="text" tabindex="1"></div>';
            }
          }
          this.$refs["result_model"].show();
        },
        (err) => {
          console.log(err);
        }
      );
    },
    onYearChange(year, month) {
      this.updateCalendarOptions(year);
      this.calendarOptions.initialDate = moment(
        `${year}-${month.toString().padStart(2, '0')}-01`
      ).format("YYYY-MM-DD");

      this.calendarOptions.visibleRange = {
        start: moment(
          `${year}-${month.toString().padStart(2, '0')}-01`
        ).format("YYYY-MM-DD"),
        end: moment(
          `${year}-${month.toString().padStart(2, '0')}-01`
        ).endOf("month").format("YYYY-MM-DD"),
      };
      this.calendarKey += 1;
    },
    addBgDarkClassToButton() {
      const todayButton = document.querySelector(`.fc-today-button`);
      if (todayButton) todayButton.classList.add("bg-primary");
      this.$nextTick(() => {
        ["prev", "next"].forEach((direction) => {
          const monthButton = document.querySelector(`.fc-${direction}-button`);
          const button = document.querySelector(`.fc-${direction}Year-button`);
          if (button) button.classList.add("bg-primary");
          if (monthButton) monthButton.classList.add("bg-primary");
        });
      });
    },

    updateCalendarOptions(year) {
      this.calendarOptions.initialDate = moment(
        `${year}-${moment().format("MM")}-01`
      ).format("YYYY-MM-DD");
      this.calendarOptions.visibleRange = {
        start: moment(`${year}-${moment().format("MM")}-01`).format(
          "YYYY-MM-DD"
        ),
        end: moment(`${year}-${moment().format("MM")}-01`)
          .endOf("month")
          .format("YYYY-MM-DD"),
      };
    },
    formatDate(dateString) {
      const date = new Date(dateString);

      const options = {
        weekday: "long", // Full name of the day of the week
        month: "long", // Full name of the month
        day: "2-digit", // Two-digit representation of the day
        year: "numeric", // Full numeric representation of the year
      };

      // Format the date using toLocaleDateString with the specified options
      const formattedDate = date.toLocaleDateString("en-US", options);

      return formattedDate;
    },
    // getEvents() {
    //   this.isLoading = true;
    // //   this.calendarOptions = [];

    //   userAPI.getEvents(
    //     {
    //       year: this.formCalendar.year,
    //       month: this.formCalendar.month,
    //       UserID: this.loginUser.userID,
    //       status: this.loginUser.Status,
    //       PracticeID: this.loginUser.PracticeID,
    //     },
    //     (res) => {
    //       res.data.forEach((element) => {
    //         this.calendarOptions.events.push(element);
    //       });
    //       this.isLoading = false;
    //     },
    //     (err) => {
    //       console.log(err);
    //       this.isLoading = false;
    //     }
    //   );
    // },
    getEvents1(startMonth, startYear) {
      this.isLoading1 = true;
      //   this.calendarOptions = [];
      if (startMonth === undefined) {
        startMonth = this.formCalendar.month;
      }
      if (startYear === undefined) {
        startYear = this.formCalendar.year;
      }
      this.calendarOptions.events.splice(0, this.calendarOptions.events.length);
      userAPI.getEvents(
        {
          year: startYear,
          month: startMonth,
          UserID: this.loginUser.userID,
          status: this.loginUser.Status,
          PracticeID: this.loginUser.PracticeID,
        },

        (res) => {
          res.data.forEach((element) => {
            this.calendarOptions.events.push(element);
          });
          this.isLoading1 = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.isLoading1 = false;
          this.isLoading = false;
        }
      );
    },
  },
  watch: {
    "formCalendar.year"(newYear, oldYear) {
      // Update calendarOptions when the year changes
      this.updateCalendarOptions(newYear);
    },
    showacrev(newVal) { 
      console.log(newVal)
      if (newVal === 0) {
        this.inputValue = "0";
      } else {
        this.inputValue = this.modelVal.REVActual;
      }
    },
  },
  mounted() {
    if (this.showacrev === 0) {
      this.inputValue = '0';
    } else {
      this.inputValue = this.modelVal.REVActual;
    }

    this.calendarOptions.datesSet = this.handleDateRangeChange;
    let user = JSON.parse(localStorage.getItem("userDetails"));
    this.loginUser = user;

    // if (user.Status == "DC" || user.Status == "CA") {
    //   this.$router.push({ name: "user_dashboard" });
    // }

    this.formCalendar.year = moment().format("Y");
    this.formCalendar.month = moment().format("M");
    this.addBgDarkClassToButton();

    // this.getEvents1()
  },
  computed: {
    computedREVActualValue() {
      // Return '0' or modelVal.REVActual based on showacrev
      return this.showacrev === 0 ? "0" : this.modelVal.REVActual;
    },
  },
};
</script>

<style>
.relative-position {
  position: relative;
}

.custom-loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  /* Ensure the loader appears above other content */
}

.custom-loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: custom-spin 2s linear infinite;
}

@keyframes custom-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
<style>
.modal-dialog.modal-md {
  max-width: 625px;
}

.panel .panel-body {
  padding: 0 10px 10px;
}

.calender-popup .panel {
  margin-bottom: 12px;
  border-radius: 0;
}

.panel .panel-body .row {
  height: auto;
  font-size: 16px;
}

.panel .panel-body .row .col-md-3 {
  min-width: 140px;
  float: left;
}

.panel .panel-body .row .col-md-3.width_auto {
  min-width: inherit;
  width: auto;
  max-width: max-content;
}

.panel .panel-body .row .col-md-3 label {
  margin: 0;
  padding-right: 5px;
  font-weight: 400;
  width: 66px;
  text-align: right;
  float: left;
  padding-top: 5px;
}

.panel .panel-body .row .col-md-3 label.color-blue {
  color: #2184da;
}

.panel .panel-body .row .col-md-3 label.color-redish {
  color: #f04b46;
}

.modal-body .row.form-pbtns {
  align-items: flex-end;
}

.modal-body .row.form-pbtns textarea.form-control {
  height: 70px;
}

.modal-body .row.form-pbtns button.btn {
  background-color: #8cc63f;
  border: 0;
  box-shadow: none;
  border-bottom: 2px solid #70a32d !important;
  font-size: 15px;
  padding: 5px 0;
  min-width: inherit;
  width: 100%;
  border-radius: 4px !important;
  font-weight: 600;
  color: #fff;
  margin: 3px 0;
  outline: none;
}

.panel .panel-body h4 {
  margin-top: 0;
  font-size: 18px;
}

.modal-body .row.form-pbtns label.control-label {
  font-size: 18px;
  font-weight: 500;
}

.modal-footer {
  display: none;
}

.panel .panel-body .row .col-md-3 .form-control {
  margin-bottom: 5px;
}

@media (max-width: 450px) {
  .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk {
    margin: 4px;
  }

  .fc-button-group {
    /* margin-bottom: 4px; */
  }

  .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk h2 {
    font-size: 18px;
  }
}


/* General styling for the calendar controls container */
.calendar-controls {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  /* Align items at the start of the container */
  gap: 1rem;
  padding: 1rem;
  border-radius: 8px;
}

/* Container for each label and select pair */
.control-group {
  display: flex;
  flex-direction: column;
}

/* Styling for labels */
.control-group label {
  font-weight: bold;
  margin-bottom: 0.5rem;
  font-size: 1rem;
}

/* Styling for select elements */
.control-group select {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  width: 150px;
  /* Adjust width as needed */
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .calendar-controls {
    flex-direction: column;
    align-items: flex-start;
  }

  .control-group {
    margin-bottom: 1rem;
  }

  .control-group select {
    width: 100%;
  }
}

.fc .fc-toolbar>*> :first-child {
  display: inline-flex;
}

.fc .fc-toolbar-title {
  font-size: 15px;
  padding: 10px;
}

button.fc-prev-button.fc-button.fc-button-primary,
button.fc-next-button.fc-button.fc-button-primary {
  background-color: white !important;
  color: #30373E;
  border: 1px solid #30373E !important;
  padding-right: 0px;
  padding-left: 0px;
  border-left-width: 0px;
  border-bottom-width: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  border-top-width: 0px;
  border-right-width: 0px;
}

.res-calendar.fc-theme-standard {
  margin-top: -90px;
}
</style>